import { NavLink } from "react-router-dom";
import React from "react";
import "./CSS/Navbar.css";

const NavBar = () => {
  return (
    <nav className="navbar">
      <NavLink to="/" className="navbar-brand">
        NBA Win Totals
      </NavLink>
      <ul className="navbar-links">
        <li>
          <NavLink to="/create" className="create-button">
            Create
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
